export default __webpack_public_path__ + "static/media/dating1.5d1f3f68.png";